import { render } from "./account-details.vue?vue&type=template&id=0aa2f954"
import script from "./account-details.vue?vue&type=script&lang=js"
export * from "./account-details.vue?vue&type=script&lang=js"

import "./account-details.vue?vue&type=style&index=0&id=0aa2f954&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__